<template lang='pug'>
v-form(ref='purchCarnetRegForm' @submit.prevent)
	v-row
		v-col
			v-select(
				v-model="selectedRegion"
				variant="solo"
				:items="regionsList"
				item-title="displayName"
				item-value="id"
				:label="$t('form_labels.regional_carnet.region', 'Regione')"
				single-line
				:loading="regionLoading"
				@update:modelValue="updateCarnetList"
			)
		v-col
			v-select(
				v-model="selectedCarnet"
				variant="solo"
				:items="carnetList"
				item-title="displayName"
				item-value="id"
				:label="$t('form_labels.regional_carnet.product', 'Prodotto')"
				single-line
				:loading="carnetLoading"
			)
</template>


<script setup>
import {inject, ref} from 'vue';
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import { onMounted } from 'vue';
import {useI18n} from "vue-i18n";



const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const axios = inject('axios');
const purchCarnetRegForm = ref(null);
const regionsList = ref([]);
const selectedRegion = ref(null);
const regionLoading = ref(false);
const carnetList = ref([]);
const selectedCarnet = ref(null);
const carnetLoading = ref(false);
const i18n = useI18n();

// TODO: DA SVILUPPARE QUANDO ABILITERANNO LA VENDITA DI CARNET REGIONALI
function loadRegionsList(){
	regionLoading.value = true;
	axios.get('trenitalia/carnet-get-regions')
	.then(res => {
		// ...



	}).catch(() => {})
	.finally(() => {
		regionLoading.value = false;
	});
}
function loadCarnetList(){
}
function updateCarnetList() {
}

onMounted(() => {
	if (stepper.step == 'search' && 'carnet' == stepper.bookingType) {
		loadRegionsList();
	}
});

defineExpose({
	purchCarnetRegForm
});
</script>

<style>
</style>